import { render, staticRenderFns } from "./NewsManage.vue?vue&type=template&id=2ab024bc&scoped=true"
import script from "./NewsManage.vue?vue&type=script&lang=js"
export * from "./NewsManage.vue?vue&type=script&lang=js"
import style0 from "./NewsManage.vue?vue&type=style&index=0&id=2ab024bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab024bc",
  null
  
)

export default component.exports